import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Gitlab = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 26 23"
    {...props}
  >
    <path
      id="gitlab_layer_7_"
      fill="hsl(from hsl(21 97% 57%) h s 49%)"
      d="M13,23l4.8-14.2H8.2L13,23z"
    />
    <path
      id="gitlab_layer_6_"
      fill="hsl(from hsl(21 97% 57%) h s 72%)"
      d="M1.5,8.8L0,13.1c-0.1,0.4,0,0.8,0.4,1.1L13,23L1.5,8.8z"
    />
    <path
      id="gitlab_layer_5_"
      fill="hsl(from hsl(21 97% 57%) h s 49%)"
      d="M1.5,8.8h6.7L5.3,0.3c-0.1-0.4-0.8-0.4-0.9,0L1.5,8.8z"
    />
    <path
      id="gitlab_layer_4_"
      fill="hsl(from hsl(21 97% 57%) h s 72%)"
      d="M24.5,8.8l1.5,4.3c0.1,0.4,0,0.8-0.4,1.1L13,23L24.5,8.8z"
    />
    <path
      id="gitlab_layer_3_"
      fill="hsl(from hsl(21 97% 57%) h s 49%)"
      d="M24.5,8.8h-6.7l2.9-8.5c0.1-0.4,0.8-0.4,0.9,0L24.5,8.8z"
    />
    <path
      id="gitlab_layer_2_"
      fill="hsl(from hsl(21 97% 57%) h s 61%)"
      d="M13,23l4.8-14.2h6.7L13,23z"
    />
    <path
      id="gitlab_layer"
      fill="hsl(from hsl(21 97% 57%) h s 61%)"
      d="M13,23L1.5,8.8h6.7L13,23z"
    />
  </svg>
);
